import "../css/global.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "jquery";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
